<template>
  <div class="foot v100">
    <div class="w980 clearfix">
      <div class="yq fl w640">
        <h3 class="pngbg">友情链接</h3>
        <ul>
          <li><a href="https://www.qq.com">腾讯网</a></li>
          <li><a href="https://www.ifanr.com">爱范儿</a></li>
          <li><a href="https://www.36kr.com">36Kr</a></li>
          <!-- <li class="fl"><a href="<%=list[i].OriginalUrl %>" target="_blank" title="<%=list[i].Name %>" onclick="this.href='<%=list[i].Url%>';"><%=list[i].Name%></a><%if (i != list.Count - 1) -->
        </ul>
      </div>
      <div class="w300 fr gz">
        <h3 class="pngbg">关注大师</h3>
        <ul>
          <li class="fr">
            <a href="http://t.qq.com/v_root" class="qqwb" target="_blank" />
          </li>
          <li class="fl">
            <a href="http://weibo.com/shuaji520" class="snwb" target="_blank" />
          </li>
          <!-- <li class="fr">
            <img alt="刷机大师官方微信" src="static/images/wxinfo.png" />
          </li> -->
          <!-- <li class="fl">
            <img alt="刷机大师官方微信" src="static/images/weixin.png" />
          </li> -->
        </ul>

        <div id="fix_twice" class="fix_twice pr">
          <span onclick="$(this).parent().hide()">关闭</span>
          <a href="http://www.mgyun.com/romastersu">
            <img
              src="static/images/fix_twice.png"
              width="91"
              height="91"
              alt="ROOT大师手机版官网快速下载"
            />
          </a>
          <label class="qr_t2">ROOT大师手机版</label>
        </div>
      </div>
    </div>
    <div class="w980 coppy mt30 clearfix">
      <div class="w640 fl b11-t" style="text-height: 50px">
        <a
          href="http://szcert.ebs.org.cn/33fe433c-8d12-44da-8fdd-40462c4b735a"
          rel="nofollow"
          target="_blank"
          style="display:inline-block; float:left;"
        >
          <!-- <img src="static/images/ebsicon.png" alt="深圳市市场监督管理局企业主体身份公示" style="border: none; height:50px;" /> -->
        </a>

        <a
          href="http://61.144.227.239:9003/webrecord/form_query.jsp"
          rel="nofollow"
          target="_blank"
          style="display:inline-block; margin:0 15px; float:left;"
        >
          <!-- <img src="static/images/sznet110wangan.gif" alt="深圳网络警察报警平台" style="border: none; height:50px;" /> -->
        </a>
        <a
          href="http://sq.ccm.gov.cn:80/ccnt/sczr/service/business/emark/toDetail/b54b38447c88460ca35e8776f3364c3b"
          rel="nofollow"
          target="_blank"
          style="display:inline-block; float:left;"
        >
          <!-- <img src="static/images/cm.png" alt="互联网文化经营单位" style="border: none; height:50px;" /> -->
        </a>
        <p style="float: left; height: 48px; line-height: 48px;">
          &nbsp;Copyright &copy;2011-2019 深圳信壹网络有限公司
          <a href="http://www.miitbeian.gov.cn" target="_blank">粤ICP备12022874号-2</a>&nbsp;
          <span>粤网文[2018]2716-881号</span>
        </p>
        <p style="float: left; height: 48px; line-height: 48px;">
          <!-- <img
            src="http://cdnpic.mgyun.com/images/gabba.png"
            align="absmiddle"
            style="float: none;"
          /> -->
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502000080"
          >粤公网安备 44030502000080号</a>
        </p>
      </div>
      <div class="fr w300 b11-t" style="height: 48px; line-height: 48px;">
        <a href="join">人才招聘</a>|
        <a href="about">关于我们</a>|
        <a href="contact">联系我们</a>
      </div>
    </div>
  </div>
  <!-- <script type="text/javascript" src="static/js/website.js"></script> -->
  <!-- <script type="text/javascript" src="static/js/index.js"></script> -->
</template>
<script>
export default {
    name: "XFooter"
}
</script>
<style scoped>
.b11-t img {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/XFooter.vue